import classNames from 'classnames';
import React from 'react';
import AppleStoreBadge from 'assets/images/apple_store_badge.png';
import GoogleStoreBadge from 'assets/images/google_store_badge.png';
import QRImage from 'assets/images/QR.png';
import { Text } from 'components/Typography';
import { Color } from 'utils/color';
import { LINKS_TO_MARKET } from '../../configConsts';
import style from './DownloadAppArea.scss';

type Props = {
  containerStyle?: string;
};

export const DownloadAppArea: React.FC<Props> = ({ containerStyle }) => {
  return (
    <div className={classNames(style.container, containerStyle)}>
      <img src={QRImage} alt="Download the Cairns Companion app QR Code" className={style.qrCodeImage} />
      <div className={style.desktopTextWrapper}>
        <Text variant="nlg" weight={500}>
          Download the Cairns Companion app Now
        </Text>
        <Text variant="md" color={Color.GRAY_800}>
          Point your camera at the code to get a link
          <br />
          to download the app
        </Text>
      </div>
      <div className={style.mobileTextWrapper}>
        <Text variant="xl" weight={500}>
          Download the Cairns Companion app
        </Text>
      </div>
      <div className={style.buttonsWrapper}>
        <div
          onClick={() => {
            open(LINKS_TO_MARKET.ios, '_blank');
          }}
        >
          <img src={AppleStoreBadge} alt="Apple store badge" />
        </div>
        {/*        <div
          onClick={() => {
            open(LINKS_TO_MARKET.android, '_blank');
          }}
        >
          <img src={GoogleStoreBadge} alt="Google store badge" />
        </div>*/}
      </div>
    </div>
  );
};
